import moscImage from '../assets/mosc.webp';
import cataractImg from '../assets/cataract.webp';
import glaucomaImg from '../assets/Glaucoma.webp';
import retinaImg from '../assets/retina.webp';
import squintImg from '../assets/squint-treatment.webp';
import generalImg from '../assets/general.webp';
import opticalImg from '../assets/optical.webp';

export const blogPosts = [
  {
    id: 4,
    slug: 'moscmm-kariambady-first-eye-hospital-malabar',
    title: 'MOSCMM Kariambady Eye Hospital: The First Eye Hospital in Malabar',
    excerpt: 'A legacy of vision and compassion. Discover the history of Malabar\'s first specialized eye hospital and its journey of serving the community.',
    content: `
      <p><a href="/">MOSCMM Kariambady Eye Hospital</a> stands as a beacon of hope and healing in Wayanad, holding the prestigious distinction of being the <strong>first specialized eye hospital in the Malabar region</strong> (North Kerala). Established in 1986 under the Malankara Orthodox Syrian Church Medical Mission, the hospital was founded with a visionary goal: to bring advanced eye care to the underserved rural and tribal populations of Wayanad.</p>
      
      <h3>A Legacy of Service</h3>
      <p>For nearly four decades, our hospital has been at the forefront of ophthalmology in the region. Starting as a humble initiative to tackle preventable blindness, it has grown into a state-of-the-art facility equipped with modern diagnostic and surgical technologies. Despite our modernization, our core mission remains unchanged: <em>Sight for All, regardless of ability to pay.</em></p>

      <h3>Why We Are Different</h3>
      <p>Being the first in Malabar doesn't just mean we are the oldest; it means we have the deepest roots in the community. Generations of families have trusted us with their vision. Our advantages include:</p>
      <ul>
        <li><strong>Experience:</strong> Over 40 years of service and hundreds of thousands of successful surgeries.</li>
        <li><strong>Charitable Heart:</strong> We are a non-profit institution. A significant portion of our work is dedicated to free or subsidized care for the poor.</li>
        <li><strong>Comprehensive Care:</strong> From routine eye exams to complex cataract surgeries and glaucoma management, we offer complete eye care under one roof.</li>
        <li><strong>Community Outreach:</strong> We don't just wait for patients; we go to them through our regular free eye camps in tribal colonies and remote villages.</li>
      </ul>

      <p>Today, MOSCMM Kariambady Eye Hospital continues to lead by example, combining medical excellence with compassionate care, proving that quality healthcare can and should be accessible to everyone.</p>
    `,
    date: 'January 20, 2024',
    author: 'MOSCMM Admin',
    category: 'History',
    image: moscImage
  },
  {
    id: 1,
    slug: 'understanding-cataracts-symptoms-causes-treatment',
    title: 'Understanding Cataracts: Symptoms, Causes, and Treatment',
    excerpt: 'Cataracts are a common eye condition that affects millions. Learn about the early signs and modern treatment options available at our hospital.',
    content: `
      <p>Cataracts are a dense, cloudy area that forms in the lens of the eye. A cataract begins when proteins in the eye form clumps that prevent the lens from sending clear images to the retina. The retina works by converting the light that comes through the lens into signals. It sends the signals to the optic nerve, which carries them to the brain.</p>
      
      <h3>Common Symptoms</h3>
      <ul>
        <li>Clouded, blurred or dim vision</li>
        <li>Increasing difficulty with vision at night</li>
        <li>Sensitivity to light and glare</li>
        <li>Need for brighter light for reading and other activities</li>
        <li>Seeing "halos" around lights</li>
      </ul>

      <h3>Treatment Options</h3>
      <p>When prescription glasses can't clear your vision, the only effective treatment for cataracts is surgery. Cataract surgery is one of the safest and most effective surgical procedures performed today.</p>
      
      <p>At <a href="/">MOSCMM Kariambady Eye Hospital</a>, we offer advanced phacoemulsification surgery with foldable IOL implantation, ensuring quick recovery and excellent visual outcomes. Learn more about our <a href="/services">Cataract Services</a>.</p>
    `,
    date: 'October 15, 2023',
    author: 'MOSCMM Admin',
    category: 'Eye Health',
    image: cataractImg
  },
  {
    id: 5,
    slug: 'glaucoma-the-silent-thief-of-sight',
    title: 'Glaucoma: The Silent Thief of Sight',
    excerpt: 'Glaucoma often has no symptoms until vision loss occurs. Early detection through regular check-ups is the key to preserving your sight.',
    content: `
      <p>Glaucoma is a group of eye conditions that damage the optic nerve, the health of which is vital for good vision. This damage is often caused by an abnormally high pressure in your eye.</p>
      
      <h3>Why is it called the "Silent Thief"?</h3>
      <p>Many forms of glaucoma have no warning signs. The effect is so gradual that you may not notice a change in vision until the condition is at an advanced stage. Vision loss due to glaucoma can't be recovered.</p>

      <h3>Advanced Glaucoma Care at MOSCMM</h3>
      <p>Our hospital provides comprehensive diagnostic facilities for early detection, including:</p>
      <ul>
        <li>Computerized Field Analysis</li>
        <li>Applanation Tonometry</li>
        <li>YAG Laser Iridotomy</li>
      </ul>
      <p>If you have a family history of glaucoma or are over 40, schedule a <a href="/patient-info">comprehensive eye exam</a> today. Explore our <a href="/services">Glaucoma Services</a> for more details.</p>
    `,
    date: 'February 10, 2024',
    author: 'MOSCMM Admin',
    category: 'Disease Management',
    image: glaucomaImg
  },
  {
    id: 6,
    slug: 'diabetic-retinopathy-protecting-vision',
    title: 'Diabetic Retinopathy: Protecting Your Vision with Diabetes',
    excerpt: 'Diabetes can affect your eyes in serious ways. Learn how our retina specialists help manage diabetic eye disease.',
    content: `
      <p>Diabetic retinopathy is a diabetes complication that affects eyes. It's caused by damage to the blood vessels of the light-sensitive tissue at the back of the eye (retina).</p>
      
      <h3>Managing Diabetic Eye Disease</h3>
      <p>At first, diabetic retinopathy may cause no symptoms or only mild vision problems. Eventually, it can cause blindness. Anyone with type 1 or type 2 diabetes is at risk.</p>

      <h3>Specialized Retina Services</h3>
      <p>At <a href="/">MOSCMM Kariambady Eye Hospital</a>, our retina specialists use advanced Diode Green Lasers and Fundus Imaging to monitor and treat retinopathy. Regular screening is essential for everyone living with diabetes.</p>
      <p>Don't wait for vision changes. Book your <a href="/contact">retina screening</a> today. Read more about our <a href="/services">Retina Services</a>.</p>
    `,
    date: 'February 25, 2024',
    author: 'MOSCMM Admin',
    category: 'Specialized Care',
    image: retinaImg
  },
  {
    id: 7,
    slug: 'pediatric-eye-care-common-issues',
    title: 'Pediatric Eye Care: Common Issues in Children',
    excerpt: 'Children’s eyes are developing rapidly. Early intervention for issues like squint or lazy eye can make a lifetime of difference.',
    content: `
      <p>Good vision is key to a child's development and success in school. However, many vision problems can go unnoticed without professional screening.</p>
      
      <h3>Conditions We Treat</h3>
      <ul>
        <li>Amblyopia (Lazy Eye)</li>
        <li>Strabismus (Squint/Crossed Eyes)</li>
        <li>Refractive Errors (Near-sightedness/Far-sightedness)</li>
      </ul>

      <h3>Our Pediatric Approach</h3>
      <p>We provide a child-friendly environment at <a href="/">MOSCMM</a> to ensure kids feel comfortable during examinations. Our specialized pediatric eye care team focuses on early diagnosis and gentle treatment plans.</p>
      <p>Give your child the gift of clear vision. Visit our <a href="/services">Pediatric Care</a> section or <a href="/patient-info">book a consultation</a>.</p>
    `,
    date: 'March 05, 2024',
    author: 'MOSCMM Admin',
    category: 'Pediatrics',
    image: squintImg
  },
  {
    id: 2,
    slug: 'importance-of-regular-eye-checkups',
    title: 'The Importance of Regular Eye Check-ups',
    excerpt: 'Many eye diseases have no early symptoms. Regular comprehensive eye exams are crucial for maintaining good vision and eye health.',
    content: `
      <p>Vision is one of our most precious senses, yet many people neglect their eye health until they notice a problem. Regular eye examinations are an essential part of preventive health care.</p>
      
      <h3>Why are exams important?</h3>
      <p>Comprehensive eye exams can detect not only vision problems but also serious health conditions such as diabetes, high blood pressure, and high cholesterol. Early detection of eye diseases like glaucoma, diabetic retinopathy, and macular degeneration is vital for preventing permanent vision loss.</p>

      <h3>How often should you go?</h3>
      <p>We recommend:</p>
      <ul>
        <li>Children: First exam at 6 months, then at age 3, and before starting school.</li>
        <li>Adults 20-60: Every two years.</li>
        <li>Over 60: Annually.</li>
      </ul>
      <p>Book your <a href="/patient-info">comprehensive eye check-up</a> with us today.</p>
    `,
    date: 'November 2, 2023',
    author: 'MOSCMM Admin',
    category: 'Prevention',
    image: generalImg
  },
  {
    id: 8,
    slug: 'dry-eye-syndrome-causes-relief',
    title: 'Dry Eye Syndrome: Causes and Modern Relief',
    excerpt: 'Itchy, gritty, or tired eyes? You might be suffering from Dry Eye Syndrome. Learn about the causes and how we can help.',
    content: `
      <p>Dry eye syndrome is a common condition that occurs when your tears aren't able to provide adequate lubrication for your eyes.</p>
      
      <h3>Symptoms to Watch For</h3>
      <ul>
        <li>A stinging, burning or scratchy sensation in your eyes</li>
        <li>Stringy mucus in or around your eyes</li>
        <li>Sensitivity to light</li>
        <li>Eye redness</li>
        <li>Difficulty wearing contact lenses</li>
      </ul>

      <h3>Modern Relief at MOSCMM</h3>
      <p>From specialized lubricating drops to managing underlying conditions, our doctors at <a href="/">MOSCMM Kariambady Eye Hospital</a> provide personalized relief plans. Modern diagnostic tools like Slit Lamp examinations help us identify the root cause of your discomfort.</p>
      <p>Get relief today. Contact our <a href="/services">General Ophthalmology</a> department or <a href="/contact">call us</a>.</p>
    `,
    date: 'March 15, 2024',
    author: 'MOSCMM Admin',
    category: 'Lifestyle',
    image: 'https://images.unsplash.com/photo-1551884170-09fb70a3a2ed?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 3,
    slug: 'digital-eye-strain-tips-modern-world',
    title: 'Digital Eye Strain: Tips for the Modern World',
    excerpt: 'With increasing screen time, digital eye strain has become a major concern. Here are practical tips to protect your eyes while using digital devices.',
    content: `
      <p>Computer Vision Syndrome, or Digital Eye Strain, describes a group of eye and vision-related problems that result from prolonged computer, tablet, e-reader and cell phone use.</p>
      
      <h3>The 20-20-20 Rule</h3>
      <p>Every 20 minutes, look at something 20 feet away for at least 20 seconds. This simple habit relaxes the focusing muscles inside the eye to reduce fatigue.</p>

      <h3>Other Helpful Tips</h3>
      <ul>
        <li>Blink often to keep eyes moist</li>
        <li>Adjust screen brightness to match room lighting</li>
        <li>Minimize glare on your screen</li>
        <li>Maintain proper posture</li>
        <li>Consider computer glasses</li>
      </ul>
      <p>Visit <a href="/">MOSCMM Kariambady Eye Hospital</a> to check if you need a prescription for computer glasses. Check our <a href="/facilities">Opticals department</a> for specialized lenses.</p>
    `,
    date: 'December 10, 2023',
    author: 'MOSCMM Admin',
    category: 'Lifestyle',
    image: 'https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }
];
